import PropTypes from "prop-types";

import {
  getDocument,
  getSimilarDocument,
  bookmarkDocument,
  unbookmarkDocument,
  filterMessagesRestarted,
  regulatoryStreamsAreClean,
} from "../../actions/filterActions";

import {
  getTilesOfTypeLinks,
  addLink,
  getTiles,
  tilesRestartMessages,
  addDocument,
  tilesAreLoaded,
  getTilesAdditional,
} from "../../actions/tileActions";

import { connect, useDispatch, useSelector } from "react-redux";

import { bindActionCreators } from "redux";

import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";

import { useParams, Link } from "react-router-dom";

import Loader from "../../utils/Loader";

import Row from "react-bootstrap/Row";

import Col from "react-bootstrap/Col";

import { Button, Modal } from "react-bootstrap";

import Container from "react-bootstrap/Container";

import { formatDate } from "../../utils/formatDate";

import { useTranslation } from "react-i18next";

import iconsExternalLink from "../../assets/svg/icons-externalLink.svg";

import iconsShare from "../../assets/svg/icons-share.svg";

import iconsJson from "../../assets/svg/icons-json.svg";

import iconsAddToList from "../../assets/svg/icons-addToList.svg";

import iconsBookmarkChecked from "../../assets/svg/icons-bookmark-checked.svg";

import iconsBookmarkUnchecked from "../../assets/svg/icons-bookmark-unchecked.svg";

import iconsAskAQuestion from "../../assets/png/icons-askAQuestion.png";

import {
  WORKSPACE_TYPE_PRIVATE,
  LOG_IN,
  REGISTER,
} from "../../constants/stringConstants";

import { useHistory } from "react-router-dom";

import AlertMessage from "../../utils/AlertMessage";

import { GET_DOCUMENT, EDIT_NEWS } from "../../constants/urls";

import FieldsInForm from "../../utils/FieldsInForm";

import CustomModal from "../../utils/CustomModal";
import DocumentAssessmentContainer from "./DocumentAssessmentContainer";
import TabsCustom from "../../utils/TabsCustom";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { isIPad13 } from "react-device-detect";
import DocumentOverviewLargeContainer from "./DocumentOverviewLargeContainer";
import DocumentOverviewSmallContainer from "./DocumentOverviewSmallContainer";
import iconsEdit from "../../assets/svg/icons-edit.svg";
import iconsDelete from "../../assets/svg/icons-delete.svg";
import dayjs from "dayjs";
import {
  getRegulatoryStream,
  getTop5Publisher,
  getTop5Countries,
  getHotTopicsPerBusiness,
  getGraphAggregationsDetails,
  getGraphAggregations,
  // addNewsItemAction,
  editNewsItemAction,
  filterSuccessMessageRaised,
  filterFailureMessageRaised,
  deleteNewsById,
} from "../../actions/filterActions";
import axios from "axios";
import {
  aiQuestionErrorMessageRaised,
  aIResponseCloseModal,
} from "../../actions/askQuestion";
import { addArrayAction } from "../../actions/newsListActions";

const STREAM_PAGE_MAX_SIZE = 10;
const STREAM_PAGE_NUMBER = 0;

const DocumentContainer = ({
  userToken,
  singleTopic,
  getDocument,
  getTilesAdditional,
  getSimilarDocument,
  singleDocumentIsLoading,
  singleSimilarDocumentIsLoading,
  singleDocument,
  singleSimilarDocument,
  loggedIn,
  currentWorkspace,
  bookmarkDocument,
  unbookmarkDocument,
  filterMessagesRestarted,
  filterFailureMessage,
  filterSuccessMessage,
  getTilesOfTypeLinks,
  tilesOfTypeLinksAreLoading,
  tilesOfTypeLinks,
  addLink,
  getTiles,
  tileErrorMessage,
  tileSuccessMessage,
  tilesRestartMessages,
  addDocument,
  tilesAreLoaded,
  topic_document_id,
  no_tile_details,
  //
  regulatoryStream,
  filtersTypes,
  deleteNewsById,
  userRights,
  setSubmitNewsOccurred,
}) => {
  const [didMount, setDidMount] = useState(false),
    { width } = useWindowDimensions(),
    [isBookmarked, setIsBookmarked] = useState(
      singleDocument ? singleDocument.bookmark : false
    ),
    [documentLoaded, setDocumentLoaded] = useState(false),
    [failureMessage, setFailureMessage] = useState(""),
    [successMessage, setSuccessMessage] = useState(""),
    [submitOccurred, setSubmitOccurred] = useState(false),
    [tile_id, setTileId] = useState(
      tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0].TILE_ID : 0
    ),
    [addToListDialogIsShown, setAddToListDialogIsShown] = useState(false),
    { id } = useParams(),
    [reference_id, setReferenceId] = useState(id),
    { t } = useTranslation(),
    history = useHistory(),
    [isShared, setIsShared] = useState(),
    [otherRequestCalled, setOtherRequestCalled] = useState(false),
    [selectedTab, setSelectedTab] = useState(""),
    argsForAddListDialog = {
      findFormErrors: () => {
        const newErrors = {};

        if (!tile_id) newErrors.TILE_ID = t("optionMustBeSelectedFromDropdown");

        return newErrors;
      },
      fields: [
        {
          name: "TILE_ID",
          type: "select",
          options: tilesOfTypeLinks,
          required: true,
          displayProperty: "TILE_NAME",
          valueProperty: "TILE_ID",
          label: t("selectList"),
          value: tile_id,
        },
      ],
      classNameReactFormal: "register-login-react-formal",
      classNameForm: "register-login-react-form",
      onSelectBoxChanged: (TILE_ID) => {
        setTileId(TILE_ID);
      },
      onSubmit: () => {
        addLink(
          userToken,
          tile_id,
          singleDocument?.news_title,
          window?.location?.href,
          "",
          history?.location?.state?.from === "search"
            ? undefined
            : singleTopic.TOPIC_ID,
          true
        );
        setTileId(tilesOfTypeLinks[0].TILE_ID);
        setAddToListDialogIsShown(false);
      },
    },
    tabsObject = {
      classNameOfTabContainer: "tabs-main-container",
      classNameOfTabs: "main-tabs",
      defaultActiveKey: "overview",
      tabs: [
        {
          disabled: false,
          eventKey: "overview",
          tabClassName: "main-tab overviewTab",
          title: t("overviewNewspage"),
          component: (
            <>
              {width > 1024 && !isIPad13 ? (
                <DocumentOverviewLargeContainer
                  document={singleDocument}
                  similarDocuments={singleSimilarDocument}
                />
              ) : (
                <DocumentOverviewSmallContainer
                  document={singleDocument}
                  similarDocuments={singleSimilarDocument}
                />
              )}
            </>
          ),
        },
        {
          disabled: false,
          eventKey: "assessment",
          tabClassName:
            !history.location.state || history.location.state.from === "topic"
              ? "main-tab assessmentTab"
              : "display-none",
          title: t("assessmentNewspage"),
          component: !loggedIn ? (
            <Container className="three-level-message-with-register topic">
              <div className="three-level-message">
                <span className="three-lvl-msg-with-register-message fs-20">
                  {t("thisFeatureIsAvailableForRegisteredUsersOnly")}
                </span>
                <Link to={REGISTER}>
                  <Button
                    as="input"
                    type="button"
                    value={t("register")}
                    variant="cyan-green"
                    className="header-button three-level-rgst-button fs-14"
                  />
                </Link>
                <span className="three-level-msg-logIn-container">
                  <span className="three-lvl-msg-log-in-first-label">
                    {t("haveAnAccount")}
                  </span>
                  <Link to={LOG_IN}>
                    <span className="three-lvl-msg-log-in-second-label cursor-pointer">
                      {t("logIn")}
                    </span>
                  </Link>
                </span>
              </div>
            </Container>
          ) : (
            <>
              <DocumentAssessmentContainer
                id={singleDocument ? singleDocument.document_id : 0}
                fromDocumentContainer={true}
                singleDocument={singleDocument}
              />
            </>
          ),
        },
      ],
    };
  const [editNewsModal, setEditNewsModal] = useState(false);
  const [submitEditNewsOccurred, setSubmitEditNewsOccurred] = useState(false);
  const [newsDateEditForm, setNewsDateEditForm] = useState("");
  const [newsTopicsEditForm, setNewsTopicsEditForm] = useState([]);
  const [freeText, setFreeText] = useState("");
  const [topicsAndUnitsDataSet, setTopicsAndUnitsDataSet] = useState([]);
  const [countriesDataSet, setCountriesDataSet] = useState([]);
  const [publisherTypesDataSet, setPublisherTypesDataSet] = useState([]);
  const [publicationTypesDataSet, setPublicationTypesDataSet] = useState([]);
  const [editedNewsLocal, setEditedNewsLocal] = useState([]);
  const [editedNewsFromStorage, setEditedNewsFromStorage] = useState("");
  const [newsIdForDeletion, setNewsIdForDeletion] = useState(null);
  const [askAQuestionModal, setAskAQuestionModal] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("reference_id", id);
  }, [id]);
  const checkSuccess = JSON.parse(sessionStorage.getItem("success"));
  useEffect(() => {
    if (checkSuccess) {
      setAskAQuestionModal(false);
    }
  }, [checkSuccess]);

  const { free_text } = useParams();

  const dispatch = useDispatch();

  const [formErrors, setFormErrors] = useState({});

  const editNewsFields = {
    fields: [
      {
        name: "NEWS_TITLE",
        type: "text",
        className: "news-title-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsTitle"),
        placeholder: t("newsTitlePlaceholder"),
      },
      {
        name: "NEWS_URL",
        type: "text",
        className: "news-url-text-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsURL"),
        placeholder: t("newsURLPlaceholder"),
      },
      {
        name: "NEWS_DESCRIPTION",
        type: "textarea",
        className: "news-description-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsDescription"),
        placeholder: t("newsDescriptionPlaceholder"),
      },
      {
        name: "NEWS_CONTENT",
        type: "textarea",
        className: "news-content-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("newsContent"),
        placeholder: t("newsContentPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER",
        type: "text",
        className: "news-publisher-text-field",
        required: true,
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsPublisher"),
        placeholder: t("newsPublisherPlaceholder"),
      },
      {
        name: "NEWS_PUBLISHER_TYPE",
        type: "select",
        className: "news-publisher-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...publisherTypesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublisherType"),
      },
      {
        name: "NEWS_PUBLICATION_TYPE",
        type: "select",
        className: "news-publication-type-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          ...publicationTypesDataSet,
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsPublicationType"),
      },
      {
        name: "NEWS_DATE",
        type: "date",
        className: "news-date-field",
        classnameofgroup: "add-news-half-width-fields-group",
        label: t("newsDate"),
        required: true,
        options: [
          {
            key: "news-date",
            name: "NEWS_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: false,
            value: formatDate(newsDateEditForm),
            onChangeDate: (value) => {
              setNewsDateEditForm(new Date(value));
            },
          },
        ],
      },
      {
        name: "NEWS_COUNTRY",
        type: "select",
        className: "news-country-select",
        classnameofgroup: "add-news-half-width-fields-group",
        options: [
          { description: "Please select", value: "Please select" },
          ...countriesDataSet,
        ],
        required: true,
        disabled: false,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCountry"),
      },
      {
        name: "NEWS_TOPICS",
        type: "multi-select",
        className: "news-topics-type-multiselect",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: topicsAndUnitsDataSet,
        selectedOptions: newsTopicsEditForm,
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsTopics"),
        placeholder: t("newsTopicsPlaceholder"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = newsTopicsEditForm.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setNewsTopicsEditForm((newsTopicsEditForm) => [
              ...newsTopicsEditForm,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setNewsTopicsEditForm(
            newsTopicsEditForm.filter((o) => o.value !== value)
          );
        },
      },
      {
        name: "NEWS_CURATED",
        type: "select",
        className: "news-curated-select",
        classnameofgroup: "add-news-half-width-fields-group",
        required: true,
        disabled: false,
        options: [
          { description: "Please select", value: "Please select" },
          { description: "No", value: "no" },
          { description: "Yes", value: "yes" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        label: t("newsCurated"),
      },
    ],

    findFormErrors: (form) => {
      const {
        NEWS_DESCRIPTION,
        NEWS_TITLE,
        NEWS_URL,
        NEWS_PUBLISHER,
        NEWS_PUBLISHER_TYPE,
        NEWS_PUBLICATION_TYPE,
        NEWS_COUNTRY,
        NEWS_CURATED,
      } = form;
      const newsErrors = {};

      if (!NEWS_TITLE || NEWS_TITLE === "") {
        newsErrors.NEWS_TITLE = "News title is mandatory field";
      }
      if (!NEWS_URL || NEWS_URL === "") {
        newsErrors.NEWS_URL = "News URL is mandatory field";
      }
      // if (!NEWS_DESCRIPTION || NEWS_DESCRIPTION === "") {
      //   newsErrors.NEWS_DESCRIPTION = "News description is mandatory field";
      // }
      if (NEWS_DESCRIPTION && NEWS_DESCRIPTION.length > 1500)
        newsErrors.NEWS_DESCRIPTION =
          "News description can't be longer than 1500 charachteres";
      if (!NEWS_PUBLISHER || NEWS_PUBLISHER === "") {
        newsErrors.NEWS_PUBLISHER = "News publisher is mandatory field";
      }
      if (
        !NEWS_PUBLISHER_TYPE ||
        NEWS_PUBLISHER_TYPE === "" ||
        NEWS_PUBLISHER_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLISHER_TYPE =
          "News publisher type is mandatory field";
      }
      if (
        !NEWS_PUBLICATION_TYPE ||
        NEWS_PUBLICATION_TYPE === "" ||
        NEWS_PUBLICATION_TYPE === "Please select"
      ) {
        newsErrors.NEWS_PUBLICATION_TYPE =
          "News publication type is mandatory field";
      }
      if (
        !NEWS_COUNTRY ||
        NEWS_COUNTRY === "" ||
        NEWS_COUNTRY === "Please select"
      ) {
        newsErrors.NEWS_COUNTRY = "News country is mandatory field";
      }
      if (
        !NEWS_CURATED ||
        NEWS_CURATED === "" ||
        NEWS_CURATED === "Please select"
      ) {
        newsErrors.NEWS_CURATED = "News curated is mandatory field";
      }
      console.log("newsErrorsDocument", newsErrors);
      setFormErrors(newsErrors);
      return newsErrors;
    },

    onSubmit: (values) => {
      let newsTopicsArr = [];
      newsTopicsEditForm.map((item) => newsTopicsArr.push(item.description));
      let newsTopicsString = newsTopicsArr.join(";");
      let editNewsValues = {
        ...values,
        NEWS_ID: editNewsModal,
        NEWS_TOPICS: newsTopicsString,
        NEWS_DATE: formatDate(newsDateEditForm),
        NEWS_CURATED: values?.NEWS_CURATED || "no",
      };
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let bodyFormData = new FormData();
      bodyFormData.append("usertoken", userToken);
      bodyFormData.append("news_title", editNewsValues.NEWS_TITLE);
      bodyFormData.append("description", editNewsValues.NEWS_DESCRIPTION);
      bodyFormData.append("content", editNewsValues.NEWS_CONTENT);
      bodyFormData.append("country", editNewsValues.NEWS_COUNTRY);
      bodyFormData.append("url", editNewsValues.NEWS_URL);
      bodyFormData.append(
        "publication_type",
        editNewsValues.NEWS_PUBLICATION_TYPE
      );
      bodyFormData.append("publisher", editNewsValues.NEWS_PUBLISHER);
      bodyFormData.append("publisher_type", editNewsValues.NEWS_PUBLISHER_TYPE);
      bodyFormData.append("publication_date", editNewsValues.NEWS_DATE);
      bodyFormData.append(
        "topics",
        newsTopicsString
        // singleTopic.TOPIC_SEARCHTAGS + ";" + editNewsValues.NEWS_TOPICS
      );
      bodyFormData.append("curated", editNewsValues.NEWS_CURATED);
      bodyFormData.append("news_id", editNewsValues.NEWS_ID);

      const asString = new URLSearchParams(bodyFormData).toString();
      axios
        .post(EDIT_NEWS, asString, axiosConfig)
        .then((response) => {
          dispatch(editNewsItemAction(response.data.RegHub_response));
          dispatch(
            filterSuccessMessageRaised("The news has been edited successfully.")
          );
          setEditNewsModal(false);
          dispatch(regulatoryStreamsAreClean());
        })
        .catch((err) => {
          dispatch(
            filterFailureMessageRaised(err.response ? err.response.data : err)
          );
          setEditNewsModal(true);
        });
      setEditNewsModal(false);
    },
  };
  const editedNews = useMemo(() => {
    return regulatoryStream.find((item) => item.id === editNewsModal);
  }, [editNewsModal, regulatoryStream]);

  useEffect(() => {
    if (editedNews) {
      localStorage.setItem("editedNewsLocal", JSON.stringify(editedNewsLocal));
      setEditedNewsLocal(editedNews);
    }
  }, [editedNews, editedNewsLocal]);

  useEffect(() => {
    let editedNewsFromStorage = JSON.parse(
      window?.localStorage?.getItem("editedNewsLocal")
    );
    setEditedNewsFromStorage(editedNewsFromStorage);
  }, []);

  useEffect(() => {
    if (editedNews) {
      setEditedNewsFromStorage(editedNews);
    } else {
      setEditedNewsFromStorage(singleDocument);
    }
  }, [singleDocument, editedNews]);

  useEffect(() => {
    setNewsDateEditForm(editedNewsFromStorage?.news_date);
    if (editedNewsFromStorage) {
      let topics = editedNewsFromStorage?.news_topic?.filter(
        (item) => !!item.comment
      );
      let formattedTopics = topics?.map((item) => {
        return {
          description: item.description,
          value: item.description,
          comment: item.comment,
        };
      });
      setNewsTopicsEditForm(formattedTopics);
    }
  }, [editNewsModal, editedNews, editedNewsFromStorage]);

  const formatDateForRequest = (date) => dayjs(date).format("YYYY-MM-DD");

  const todayDate = formatDateForRequest(Date.now());
  const todayDateYearAgo = formatDateForRequest(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  );

  useEffect(() => {
    if (!didMount) {
      setDidMount(true);
    }

    if ((didMount && !otherRequestCalled) || free_text !== freeText) {
      getGraphAggregations(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getGraphAggregationsDetails(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getTop5Publisher(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getTop5Countries(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getHotTopicsPerBusiness(
        userToken,
        free_text,
        "",
        "",
        "",
        todayDateYearAgo,
        todayDate
      );
      getRegulatoryStream(
        userToken,
        "",
        free_text,
        "",
        "",
        todayDateYearAgo,
        todayDate,
        "",
        "",
        "",
        STREAM_PAGE_NUMBER,
        STREAM_PAGE_MAX_SIZE
      );
      setOtherRequestCalled(true);
      setFreeText(free_text);
    }
  }, [
    userToken,
    didMount,
    setDidMount,
    otherRequestCalled,
    setOtherRequestCalled,
    free_text,
    freeText,
    setFreeText,
    todayDateYearAgo,
    todayDate,
  ]);

  useEffect(() => {
    if (
      filtersTypes.length &&
      (!countriesDataSet.length ||
        !publicationTypesDataSet.length ||
        !publisherTypesDataSet.length ||
        !topicsAndUnitsDataSet.length)
    ) {
      if (
        Object.keys(filtersTypes[0]).length &&
        !publisherTypesDataSet.length
      ) {
        // ADDED alphabetical order

        const sortedPublisherTypes = Object.keys(filtersTypes[0])
          .map((publisher_type) => ({
            description: filtersTypes[0][publisher_type],
            value: filtersTypes[0][publisher_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublisherTypesDataSet(sortedPublisherTypes);

        // Object.keys(filtersTypes[0]).forEach((publisher_type) => {
        //   setPublisherTypesDataSet((publisherTypesDataSet) => [
        //     ...publisherTypesDataSet,
        //     {
        //       description: filtersTypes[0][publisher_type],
        //       value: filtersTypes[0][publisher_type],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[1]).length &&
        !publicationTypesDataSet.length
      ) {
        // ADDED alphabetical order
        const sortedPublisherTypesDataSet = Object.keys(filtersTypes[1])
          .map((publication_type) => ({
            description: filtersTypes[1][publication_type],
            value: filtersTypes[1][publication_type],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setPublicationTypesDataSet(sortedPublisherTypesDataSet);

        // Object.keys(filtersTypes[1]).forEach((publication_type) => {
        //   setPublicationTypesDataSet((publicationTypesDataSet) => [
        //     ...publicationTypesDataSet,
        //     {
        //       description: filtersTypes[1][publication_type],
        //       value: filtersTypes[1][publication_type],
        //     },
        //   ]);
        // });
      }

      if (Object.keys(filtersTypes[2]).length && !countriesDataSet.length) {
        // ADDED alphabetical order
        const sortedCountriesDataSet = Object.keys(filtersTypes[2])
          .map((country) => ({
            description: filtersTypes[2][country],
            value: filtersTypes[2][country],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setCountriesDataSet(sortedCountriesDataSet);
        // Object.keys(filtersTypes[2]).forEach((country) => {
        //   setCountriesDataSet((countriesDataSet) => [
        //     ...countriesDataSet,
        //     {
        //       description: filtersTypes[2][country],
        //       value: filtersTypes[2][country],
        //     },
        //   ]);
        // });
      }

      if (
        Object.keys(filtersTypes[3]).length &&
        !topicsAndUnitsDataSet.length
      ) {
        // ADDED alphabetical order
        const sortedTopicsAndUnitsDataSet = Object.keys(filtersTypes[3])
          .map((topicOrUnit) => ({
            description: filtersTypes[3][topicOrUnit],
            value: filtersTypes[3][topicOrUnit],
          }))
          .sort((a, b) => a.description.localeCompare(b.description));

        setTopicsAndUnitsDataSet(sortedTopicsAndUnitsDataSet);
        // Object.keys(filtersTypes[3]).forEach((topicOrUnit) => {
        //   setTopicsAndUnitsDataSet((topicsAndUnitsDataSet) => [
        //     ...topicsAndUnitsDataSet,
        //     {
        //       description: filtersTypes[3][topicOrUnit],
        //       value: filtersTypes[3][topicOrUnit],
        //     },
        //   ]);
        // });
      }
    }
  }, [
    filtersTypes,
    countriesDataSet.length,
    publicationTypesDataSet.length,
    publisherTypesDataSet.length,
    topicsAndUnitsDataSet.length,
  ]);

  useEffect(() => {
    getRegulatoryStream(
      userToken,
      "",
      freeText,
      "",
      "",
      todayDateYearAgo,
      todayDate,
      "",
      "",
      "",
      STREAM_PAGE_NUMBER,
      STREAM_PAGE_MAX_SIZE
    );
  }, [
    todayDate,
    todayDateYearAgo,
    freeText,
    userToken,
    singleTopic.TOPIC_ID,
    singleTopic.TOPIC_SEARCHTAGS,
  ]);

  const showDeleteNewsModal = useCallback((id) => {
    setNewsIdForDeletion(id);
    console.log("id :>> ", id);
  }, []);

  const hideDeleteNewsModal = useCallback(() => {
    setNewsIdForDeletion(null);
  }, []);

  const approveDeleteNewsModal = useCallback(async () => {
    deleteNewsById(userToken, newsIdForDeletion);
    hideDeleteNewsModal();
    dispatch(addArrayAction([]));
    history.goBack();
  }, [
    deleteNewsById,
    dispatch,
    hideDeleteNewsModal,
    history,
    newsIdForDeletion,
    userToken,
  ]);

  useEffect(() => {
    let from = "";

    if (id !== reference_id) {
      getDocument(
        userToken,
        id,
        from === "topic" ? singleTopic.TOPIC_ID : undefined
      );
      getTilesAdditional(
        userToken,
        singleDocument ? singleDocument.document_id : 0
      );
      getSimilarDocument(userToken, id);
      getTilesOfTypeLinks(
        userToken,
        singleTopic.TOPIC_ID
          ? singleTopic.TOPIC_ID
          : localStorage.getItem("singleTopicId"),
        true
      );

      setReferenceId(id);
    }

    if (history.location.state) {
      from = history.location.state.from;
    }

    if (filterFailureMessage) {
      setFailureMessage(filterFailureMessage);
    }

    if (filterSuccessMessage) {
      setSuccessMessage(filterSuccessMessage);
    }

    if (!didMount) {
      getDocument(
        userToken,
        id,
        from === "topic" ? singleTopic.TOPIC_ID : undefined
      );
      getTilesAdditional(
        userToken,
        singleDocument ? singleDocument.document_id : 0
      );
      getSimilarDocument(userToken, id);
      getTilesOfTypeLinks(
        userToken,
        singleTopic.TOPIC_ID
          ? singleTopic.TOPIC_ID
          : localStorage.getItem("singleTopicId"),
        true
      );

      setDidMount(true);
    }

    if (didMount && !documentLoaded && Object.keys(singleDocument).length > 0) {
      setIsBookmarked(singleDocument.bookmark);
      setDocumentLoaded(true);
    }

    if (singleDocument.bookmark !== isBookmarked) {
      setIsBookmarked(singleDocument.bookmark);

      if (from === "topic") {
        if (singleDocument && singleDocument.document_id === 0) {
          tilesAreLoaded([]);
        } else {
          getTiles(
            userToken,
            singleDocument ? singleDocument.document_id : 0,
            singleDocument.TOPIC_ID,
            true
          );
          getTilesAdditional(
            userToken,
            singleDocument ? singleDocument.document_id : 0,
            singleDocument.TOPIC_ID,
            true
          );
        }
      }
    }

    if (tilesOfTypeLinks.length > 0 && tile_id === 0) {
      setTileId(tilesOfTypeLinks[0].TILE_ID);
    }

    if (tileErrorMessage) {
      setFailureMessage(tileErrorMessage);
    }

    if (tileSuccessMessage) {
      setSuccessMessage(tileSuccessMessage);
    }
  }, [
    userToken,
    singleTopic,
    didMount,
    id,
    getDocument,
    getTilesAdditional,
    getSimilarDocument,
    documentLoaded,
    singleDocument,
    filterFailureMessage,
    filterSuccessMessage,
    getTilesOfTypeLinks,
    getTiles,
    setIsBookmarked,
    isBookmarked,
    history.location.state,
    tile_id,
    tilesOfTypeLinks,
    tileErrorMessage,
    tileSuccessMessage,
    addDocument,
    reference_id,
    tilesAreLoaded,
    topic_document_id,
    no_tile_details,
  ]);

  useEffect(() => {
    history.replace({
      search: `&tab=${selectedTab}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  useLayoutEffect(() => {
    let historySearch = history.location.search;
    if (!historySearch || historySearch.includes("overview")) {
      history.replace({
        search: `&tab=overview`,
      });
      setSelectedTab("overview");
    }
    if (historySearch.includes("assessment")) {
      history.replace({
        search: `&tab=assessment`,
      });
      setSelectedTab("assessment");
    }
    localStorage.setItem("singleDocumentTitleName", singleDocument.news_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onShareClick() {
    setIsShared(true);

    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(window.location.href);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  }

  function onShareClose() {
    setIsShared(false);
  }

  const askAQuestionFields = {
    fields: [
      {
        name: "YOUR_QUESTION",
        type: "textarea",
        className: "ask-question-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("yourQuestion"),
        placeholder: t("yourQuestionPlaceholder"),
      },
      {
        name: "THE_ANSWER",
        type: "textarea",
        className: "answer-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("theAnswer"),
      },
    ],
    findFormErrors: (form) => {
      const { YOUR_QUESTION } = form;

      const newsErrors = {};
      if (!YOUR_QUESTION || YOUR_QUESTION === "") {
        newsErrors.YOUR_QUESTION = "Your Question is mandatory field";
      }
      return newsErrors;
    },
  };

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const askQuestionFromStore = useSelector((state) => {
    return state.askQuestionReducer;
  });
  useEffect(() => {
    if (askQuestionFromStore.aiQuestionErrorMessageRaised !== "") {
      setFailureMessage(askQuestionFromStore.aiQuestionErrorMessageRaised);
      setAskAQuestionModal(false);

      dispatch(aiQuestionErrorMessageRaised(""));
      dispatch(aIResponseCloseModal());
    }
  }, [
    askQuestionFromStore.aiQuestionErrorMessageRaised,
    dispatch,
    setAskAQuestionModal,
  ]);

  useEffect(() => {
    if (singleDocument) {
      localStorage.setItem(
        "singleDocumentTitleName",
        singleDocument.news_title
      );
    }
  }, [singleDocument]);
  return (
    <div>
      {singleDocumentIsLoading ||
      singleSimilarDocumentIsLoading ||
      tilesOfTypeLinksAreLoading ? (
        <Loader />
      ) : (
        <Container
          expand="lg"
          className="home-page-container document-homepage-container"
        >
          <Row className="document-header-row">
            <Col className="document-header-first-col">
              <Col className="document-header-first-sub-col">
                <span className="heading fs-21">
                  {singleDocument.news_title}
                </span>
                <Row className="subline-heading-row">
                  <span className="subheading fs-10 first-document-subheading">
                    {t("lastUpdated") +
                      ": " +
                      formatDate(
                        new Date(singleDocument.news_date),
                        "dd.mm.yyyy"
                      )}
                  </span>
                  <span className="subheading fs-10 second-document-subheading">
                    {t("country") + ": " + singleDocument.source_country}
                  </span>
                </Row>
              </Col>
              <Col className="document-header-second-sub-col">
                <span className="one-group">
                  <span className="information-document-heading information-document-heading-bolder fs-14">
                    {t("publisher")}
                  </span>
                  <span className="information-document-heading fs-14">
                    {singleDocument.source_name}
                  </span>
                </span>
                <span className="one-group">
                  <span className="information-document-heading information-document-heading-bolder fs-14">
                    {t("publicationType")}
                  </span>
                  <span className="information-document-heading fs-14">
                    {singleDocument.news_type}
                  </span>
                </span>
              </Col>
            </Col>
            <Col className="document-header-second-col">
              <Row className="document-header-second-col-row">
                <Button
                  className={
                    "view-source-document fs-14 cursor-pointer"
                    // loggedIn
                    //   ? "view-source-document fs-14 cursor-pointer"
                    //   : "view-source-document fs-14 cursor-not-allowed"
                  }
                  type="button"
                  // disabled={!loggedIn}
                  onClick={() =>
                    window.open(singleDocument.news_link, "_blank")
                  }
                >
                  <img
                    width={24}
                    height={24}
                    src={iconsExternalLink}
                    className="view-source-icon"
                  />
                  {t("viewSource")}
                </Button>
              </Row>
              <Row className="document-header-second-col-row">
                <span
                  className={
                    loggedIn
                      ? "document-header-right-option cursor-pointer"
                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                  }
                  onClick={() => {
                    if (loggedIn) {
                      setAddToListDialogIsShown(true);
                    }
                  }}
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={iconsAddToList}
                  />
                  <span className="document-header-right-option-label">
                    {t("addToList")}
                  </span>
                </span>
                <span
                  className={
                    loggedIn
                      ? "document-header-right-option cursor-pointer"
                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                  }
                  onClick={() => {
                    if (loggedIn) {
                      setEditNewsModal(id);
                      sessionStorage.setItem(
                        "news_url",
                        editedNewsFromStorage.news_link
                      );
                    }
                  }}
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={iconsEdit}
                  />
                  <span className="document-header-right-option-label">
                    {t("edit")}
                  </span>
                </span>
                <span
                  className={
                    loggedIn
                      ? "document-header-right-option cursor-pointer"
                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                  }
                  onClick={() => {
                    if (loggedIn) {
                      showDeleteNewsModal(id);
                    }
                  }}
                  disabled={
                    !(
                      userRights.USER_RIGHT?.toLowerCase().includes(
                        "read_write_delete"
                      ) ||
                      userRights.USER_RIGHT?.toLowerCase().includes(
                        "read_write_delete_new"
                      ) ||
                      userRights.USER_RIGHT?.toLowerCase().includes("partner")
                    )
                  }
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={iconsDelete}
                  />
                  <span className="document-header-right-option-label">
                    {t("delete")}
                  </span>
                </span>
                <span
                  className={
                    loggedIn
                      ? history?.location?.state?.from === "search"
                        ? "display-none"
                        : "document-header-right-option cursor-pointer"
                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                  }
                  onClick={() => {
                    if (loggedIn) {
                      if (isBookmarked) {
                        unbookmarkDocument(
                          userToken,
                          singleDocument.news_title,
                          singleTopic.TOPIC_ID,
                          id
                        );
                      } else {
                        bookmarkDocument(
                          userToken,
                          singleDocument?.news_title,
                          singleTopic.TOPIC_ID,
                          // history?.location?.state === "topic"
                          //   ? singleTopic.TOPIC_ID
                          //   : "",
                          id
                        );
                      }
                    }
                  }}
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={
                      isBookmarked
                        ? iconsBookmarkChecked
                        : iconsBookmarkUnchecked
                    }
                  />
                  <span className="document-header-right-option-label">
                    {!isBookmarked
                      ? t("bookmarkPublication")
                      : t("unbookmarkPublication")}
                  </span>
                </span>
                <span
                  className={
                    loggedIn &&
                    currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE
                      ? "document-header-right-option cursor-pointer"
                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                  }
                  onClick={() => {
                    if (
                      loggedIn &&
                      currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE
                    ) {
                      window.open(
                        GET_DOCUMENT +
                          "?usertoken=" +
                          userToken +
                          "&reference_id=" +
                          id,
                        "_blank"
                      );
                    }
                  }}
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={iconsJson}
                  />
                  <span className="document-header-right-option-label">
                    {t("getJSONStream")}
                  </span>
                </span>
                <span
                  className="document-header-right-option cursor-pointer"
                  onClick={() => onShareClick()}
                >
                  <img
                    width={24}
                    height={24}
                    className="right-options-icon"
                    src={iconsShare}
                  />
                  <span className="document-header-right-option-label">
                    {t("share")}
                  </span>
                </span>
                <span
                  className="document-header-right-option ask-btn-document"
                  onClick={() => setAskAQuestionModal(true)}
                >
                  <img
                    width={15}
                    height={15}
                    src={iconsAskAQuestion}
                    className="left-options-icon"
                    style={{ marginRight: "5px" }}
                  />
                  <span className="document-header-right-option-label">
                    {t("askaQuestion")}
                  </span>
                </span>
              </Row>
            </Col>
          </Row>
          <hr className="document-container-hr" />
          <TabsCustom
            classNameOfTabs={tabsObject.classNameOfTabs}
            defaultActiveKey={tabsObject.defaultActiveKey}
            tabs={tabsObject.tabs}
            classNameOfTabContainer={tabsObject.classNameOfTabContainer}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <CustomModal
            titleOfModal={t("addToList")}
            positiveButton={t("addToList")}
            negativeButton={t("cancel")}
            positiveAction={() => setSubmitOccurred(true)}
            negativeAction={() => {
              setAddToListDialogIsShown(false);
              setTileId(
                tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0].TILE_ID : 0
              );
              setEditedNewsFromStorage("");
            }}
            setIsShown={setAddToListDialogIsShown}
            isShown={addToListDialogIsShown}
            classNameOfModal="add-to-list-modal additional-add-modal"
            formId="add-new-topic-group-form"
            content={
              <FieldsInForm
                idOfForm="add-to-list-form"
                fields={argsForAddListDialog.fields}
                onSubmit={argsForAddListDialog.onSubmit}
                findFormErrors={argsForAddListDialog.findFormErrors}
                setSubmitOccurred={setSubmitOccurred}
                submitOccurred={submitOccurred}
                classNameForm={argsForAddListDialog.classNameForm}
                onSelectBoxChanged={argsForAddListDialog.onSelectBoxChanged}
              />
            }
            isBackdrop="static"
          />
          <CustomModal
            positiveButton={t("newsSaveBtn")}
            positiveAction={() => {
              setSubmitNewsOccurred(true);
            }}
            titleOfModal={t("askaQuestion")}
            negativeAction={() => {
              setAskAQuestionModal(false);
              dispatch(aIResponseCloseModal());
              sessionStorage.removeItem("separateNewsAsk");
              // sessionStorage.removeItem("reference_id");
            }}
            isShown={askAQuestionModal}
            setIsShown={setAskAQuestionModal}
            isBackdrop="static"
            isCentered={true}
            classNameOfModal="reghub-modal add-news-modal ask"
            content={
              <FieldsInForm
                idOfForm="ask-a-question-form"
                fields={askAQuestionFields.fields}
                findFormErrors={askAQuestionFields.findFormErrors}
              />
            }
          />
          {console.log(newsTopicsEditForm)}
          {!!editNewsModal && (
            <CustomModal
              positiveButton={t("newsSaveBtn")}
              positiveAction={() => {
                setSubmitEditNewsOccurred(true);
              }}
              titleOfModal={t("editNews")}
              negativeButton={t("close")}
              negativeAction={() => setEditNewsModal(null)}
              isShown={!!editNewsModal}
              setIsShown={setEditNewsModal}
              isBackdrop="static"
              isCentered={true}
              isPositiveButtonDisabled={
                Object.keys(formErrors).length > 0 ||
                newsTopicsEditForm.length < 1
              }
              classNameOfModal="reghub-modal add-news-modal"
              content={
                <FieldsInForm
                  existingData={{
                    NEWS_TITLE: editedNewsFromStorage?.news_title,
                    NEWS_URL: editedNewsFromStorage?.news_link,
                    NEWS_DESCRIPTION: editedNewsFromStorage?.news_summary,
                    NEWS_CONTENT: editedNewsFromStorage?.news_content,
                    NEWS_PUBLISHER: editedNewsFromStorage?.source_name,
                    NEWS_PUBLISHER_TYPE: editedNewsFromStorage?.source_type,
                    NEWS_PUBLICATION_TYPE: editedNewsFromStorage?.news_type,
                    NEWS_COUNTRY: editedNewsFromStorage?.source_country,
                    NEWS_TOPICS: "Recruiting",
                    NEWS_CURATED:
                      editedNewsFromStorage?.news_label === "curated"
                        ? "yes"
                        : "no",
                  }}
                  idOfForm="add-news-form"
                  fields={editNewsFields.fields}
                  findFormErrors={editNewsFields.findFormErrors}
                  onSubmit={editNewsFields.onSubmit}
                  submitOccurred={submitEditNewsOccurred}
                  setSubmitOccurred={setSubmitEditNewsOccurred}
                />
              }
            />
          )}
          {/* positiveButton={t("newsSaveBtn")} */}
          <Modal centered={true} show={!!newsIdForDeletion} backdrop={true}>
            <Modal.Header>{t("deleteNewMessage")}</Modal.Header>
            <Modal.Footer>
              <Button
                onClick={hideDeleteNewsModal}
                className="modal-negative-button apply-bg-white-color fs-14"
              >
                {t("cancel")}
              </Button>
              <Button
                onClick={approveDeleteNewsModal}
                className="modal-positive-button apply-bg-approx-analog-color approve-news-deletion-btn fs-14"
              >
                {t("yes")}
              </Button>
            </Modal.Footer>
          </Modal>
          {isShared ? (
            <AlertMessage
              variant="success"
              onClose={() => onShareClose()}
              successHeading={t("success")}
              mainMessage={t("copyURLMessage")}
            />
          ) : (
            <div className="display-none" />
          )}
          {failureMessage ? (
            <AlertMessage
              variant="danger"
              onClose={() => {
                filterMessagesRestarted();
                tilesRestartMessages();
                setFailureMessage("");
              }}
              successHeading={t("failure")}
              mainMessage={failureMessage}
            />
          ) : (
            <div className="display-none" />
          )}
          {successMessage ? (
            <AlertMessage
              variant="success"
              onClose={() => {
                filterMessagesRestarted();
                tilesRestartMessages();
                setSuccessMessage("");
              }}
              successHeading={t("success")}
              mainMessage={successMessage}
            />
          ) : (
            <div className="display-none" />
          )}
        </Container>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    singleTopic: state.topicReducer.singleTopic,
    singleDocumentIsLoading: state.filterReducer.singleDocumentIsLoading,
    singleSimilarDocumentIsLoading:
      state.filterReducer.singleSimilarDocumentIsLoading,
    singleDocument: state.filterReducer.singleDocument,
    singleSimilarDocument: state.filterReducer.singleSimilarDocument,
    loggedIn: state.userReducer.loggedIn,
    currentWorkspace: state.configReducer.currentWorkspace,
    filterFailureMessage: state.filterReducer.filterFailureMessage,
    filterSuccessMessage: state.filterReducer.filterSuccessMessage,
    tilesOfTypeLinksAreLoading: state.tileReducer.tilesOfTypeLinksAreLoading,
    tilesOfTypeLinks: state.tileReducer.tilesOfTypeLinks,
    tileSuccessMessage: state.tileReducer.tileSuccessMessage,
    tileErrorMessage: state.tileReducer.tileErrorMessage,
    filtersAreLoading: state.filterReducer.filtersAreLoading,
    filtersTypesAreLoading: state.filterReducer.filtersTypesAreLoading,
    regulatoryStreamAreLoading: state.filterReducer.regulatoryStreamAreLoading,
    regulatoryStreamLoadedWithError:
      state.filterReducer.regulatoryStreamLoadedWithError,
    top5PublishersAreLoading: state.filterReducer.top5PublishersAreLoading,
    top5CountriesAreLoading: state.filterReducer.top5CountriesAreLoading,
    hotTopicsAndBusinessUnitsAreLoading:
      state.filterReducer.hotTopicsAndBusinessUnitsAreLoading,
    graphAggregationsAreLoading:
      state.filterReducer.graphAggregationsAreLoading,
    graphAggregationsTotalAmount:
      state.filterReducer.graphAggregationsTotalAmount,
    top5Publishers: state.filterReducer.top5Publishers,
    top5Countries: state.filterReducer.top5Countries,
    hotTopics: state.filterReducer.hotTopics,
    hotBusinessUnits: state.filterReducer.hotBusinessUnits,
    regulatoryStream: state.filterReducer.regulatoryStream,
    filtersTypes: state.filterReducer.filtersTypes,
    userRights: state.userReducer.userRights,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDocument: bindActionCreators(getDocument, dispatch),
    getTilesAdditional: bindActionCreators(getTilesAdditional, dispatch),
    getSimilarDocument: bindActionCreators(getSimilarDocument, dispatch),
    bookmarkDocument: bindActionCreators(bookmarkDocument, dispatch),
    filterMessagesRestarted: bindActionCreators(
      filterMessagesRestarted,
      dispatch
    ),
    getTilesOfTypeLinks: bindActionCreators(getTilesOfTypeLinks, dispatch),
    addLink: bindActionCreators(addLink, dispatch),
    getTiles: bindActionCreators(getTiles, dispatch),
    unbookmarkDocument: bindActionCreators(unbookmarkDocument, dispatch),
    tilesRestartMessages: bindActionCreators(tilesRestartMessages, dispatch),
    addDocument: bindActionCreators(addDocument, dispatch),
    tilesAreLoaded: bindActionCreators(tilesAreLoaded, dispatch),
    deleteNewsById: bindActionCreators(deleteNewsById, dispatch),
  };
};

DocumentContainer.propTypes = {
  userToken: PropTypes.string.isRequired,
  singleTopic: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    SUBSCRIPTION: PropTypes.string,
    TOPIC_AUDIENCE: PropTypes.string,
    TOPIC_ICON_PATH: PropTypes.string,
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
    TOPIC_SEARCHTAGS: PropTypes.string,
    TOPIC_STATUS: PropTypes.string,
    SUBSCRIPTION_ID: PropTypes.string,
    TOPIC_TYPE: PropTypes.string,
  }).isRequired,
  getDocument: PropTypes.func.isRequired,
  getTilesAdditional: PropTypes.func.isRequired,
  getSimilarDocument: PropTypes.func.isRequired,
  singleDocumentIsLoading: PropTypes.bool.isRequired,
  singleSimilarDocumentIsLoading: PropTypes.bool.isRequired,
  singleDocument: PropTypes.shape({
    bookmark: PropTypes.bool,
    news_title: PropTypes.string,
    news_date: PropTypes.string,
    source_country: PropTypes.string,
    source_name: PropTypes.string,
    news_type: PropTypes.string,
    news_link: PropTypes.string,
    document_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    TOPIC_ID: PropTypes.string,
    id: PropTypes.string,
  }),
  singleSimilarDocument: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loggedIn: PropTypes.bool.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }),
  bookmarkDocument: PropTypes.func.isRequired,
  filterMessagesRestarted: PropTypes.func.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  getTilesOfTypeLinks: PropTypes.func.isRequired,
  tilesOfTypeLinksAreLoading: PropTypes.bool.isRequired,
  tilesOfTypeLinks: PropTypes.arrayOf(
    PropTypes.shape({
      TILE_ID: PropTypes.number,
    })
  ).isRequired,
  addLink: PropTypes.func.isRequired,
  getTiles: PropTypes.func.isRequired,
  unbookmarkDocument: PropTypes.func.isRequired,
  tileSuccessMessage: PropTypes.string.isRequired,
  tileErrorMessage: PropTypes.string.isRequired,
  tilesRestartMessages: PropTypes.func.isRequired,
  addDocument: PropTypes.func.isRequired,
  tilesAreLoaded: PropTypes.func.isRequired,
  topic_document_id: PropTypes.string.isRequired,
  no_tile_details: PropTypes.bool,
  filtersAreLoading: PropTypes.bool.isRequired,
  filtersTypesAreLoading: PropTypes.bool.isRequired,
  regulatoryStreamAreLoading: PropTypes.bool.isRequired,
  regulatoryStreamLoadedWithError: PropTypes.bool.isRequired,
  top5PublishersAreLoading: PropTypes.bool.isRequired,
  top5CountriesAreLoading: PropTypes.bool.isRequired,
  hotTopicsAndBusinessUnitsAreLoading: PropTypes.bool.isRequired,
  graphAggregationsAreLoading: PropTypes.bool.isRequired,
  regulatoryStream: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filtersTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  deleteNewsById: PropTypes.func.isRequired,
  userRights: PropTypes.shape({
    USER_RIGHT: PropTypes.string,
  }).isRequired,
  setSubmitNewsOccurred: PropTypes.func.isRequired,
};

DocumentContainer.defaultProps = {
  userToken: "",
  singleTopic: {},
  getDocument: () => {},
  getTilesAdditional: () => {},
  getSimilarDocument: () => {},
  singleDocumentIsLoading: false,
  singleSimilarDocumentIsLoading: false,
  // singleDocument: {},
  singleDocument: {
    id: "",
  },
  singleSimilarDocument: [],
  loggedIn: false,
  currentWorkspace: {},
  bookmarkDocument: () => {},
  filterMessagesRestarted: () => {},
  filterFailureMessage: "",
  filterSuccessMessage: "",
  getTilesOfTypeLinks: () => {},
  tilesOfTypeLinksAreLoading: false,
  tilesOfTypeLinks: [],
  addLink: () => {},
  getTiles: () => {},
  unbookmarkDocument: () => {},
  tileSuccessMessage: "",
  tileErrorMessage: "",
  tilesRestartMessages: () => {},
  addDocument: () => {},
  tilesAreLoaded: () => {},
  topic_document_id: "",
  no_tile_details: true,
  singleTopicIsLoading: false,
  singleTopicIsLoadedWithError: false,
  filtersAreLoading: false,
  filtersTypesAreLoading: false,
  regulatoryStreamAreLoading: false,
  top5PublishersAreLoading: false,
  top5CountriesAreLoading: false,
  hotTopicsAndBusinessUnitsAreLoading: false,
  graphAggregationsAreLoading: false,
  regulatoryStream: [],
  regulatoryStreamLoadedWithError: false,
  regulatoryStreamPaginationError: false,
  setEditNewsModal: () => {},
  filtersTypes: [],
  showDeleteNewsModal: () => {},
  deleteNewsById: () => {},
  userRights: { USER_RIGHT: "" },
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentContainer);
